import { fromEvent, Subscription } from 'rxjs';
import { LocationStrategy } from '@angular/common';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class LocationStrategyService {
  subscription: Subscription;

  constructor(private locationStrategy: LocationStrategy) {}

  preventBackButton() {
    history.pushState(null, null, location.href);
    this.subscription = fromEvent(window, 'popstate').subscribe(() => {
      if (location.href.includes('main')) {
        history.pushState(null, null, location.href);
      }
    });
  }

  unsubscribe() {
    this.subscription.unsubscribe();
  }
}
